<template>
  <PageContainer title="Enviar avisos para Auto Escolas">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box space="medium" v-else>
      <form @submit.prevent="handleSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <div class="input-container input-full">
              <legend>Auto escolas</legend>

              <Multiselect
                v-model="schemas"
                :options="schemaOptions"
                :multiple="true"
                :searchable="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                selectLabel="Selecionar"
                selectedLabel="Selecionado"
                deselectLabel="Remover"
                placeholder="Selecione as auto escolas"
                label="text"
                track-by="value"
                class="input input-full"
              />
            </div>
          </div>

          <div class="inputs-row">
            <Input
              class="input-full"
              :modelValue="titulo"
              @update:modelValue="$event => (titulo = $event)"
              legend="Título"
              placeholder="Título do aviso"
              :disabled="loading"
            />

            <Input
              class="input-full"
              :modelValue="user"
              @update:modelValue="$event => (user = $event)"
              legend="Usuário monitoramento"
              placeholder="Nome do usuário"
              :disabled="loading"
            />
          </div>

          <div class="inputs-row">
            <Textarea
              legend="Aviso"
              @update:modelValue="$event => (this.aviso = $event)"
              :modelValue="aviso"
              :disabled="loading"
              placeholder="Conteúdo do aviso"
              class="input-full"
            />
          </div>

          <div class="buttons">
            <Button
              type="button"
              @handle:click="clearInputs"
              text="Limpar"
              :fill="false"
              color="danger"
              :disabled="loading"
            >
              <CloseCircleOutline :size="18" />
            </Button>

            <Button type="submit" text="Consultar" color="primary" :disabled="loading">
              <Magnify :size="18" />
            </Button>
          </div>
        </div>
      </form>
    </Box>
  </PageContainer>
</template>

<script>
import Box from 'core/Box'
import Button from 'core/Button'
import Input from 'core/Input'
import LoadingSpinner from 'core/LoadingSpinner'
import PageContainer from 'core/PageContainer'
import Textarea from 'core/Textarea'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import Multiselect from 'vue-multiselect'

export default {
  name: 'form_avisos',
  components: {
    PageContainer,
    Box,
    LoadingSpinner,
    Input,
    Button,
    Textarea,
    Multiselect,

    CloseCircleOutline,
    Magnify,
  },
  data() {
    return {
      titulo: '',
      user: '',
      aviso: '',
      schemaOptions: [],
      schemas: [],
      loaded: false,
      loading: false,
    }
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then(res => {
          this.schemaOptions = res.body.dados.map(cfc => ({
            value: cfc.tenant_schema,
            text: cfc.nome_fantasia,
          }))
        })
        .catch(error => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    clearInputs() {
      this.schemas = []
      this.titulo = ''
      this.user = ''
      this.aviso = ''
    },
    async handleSubmit() {
      if (this.validadeInputs()) {
        this.loading = true

        const data = {
          autoescolas: this.schemas.map(schema => schema.value),
          titulo: this.titulo,
          descricao: this.aviso,
          usuario: this.user,
        }

        await this.$http
          .post(`${process.env.VUE_APP_URL_API_V2}/autoescola/envio-avisos`, data)
          .then(res => {
            this.$toasted.show('Aviso Criado com sucesso', {
              icon: 'fa-check',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
            })
          })
          .catch(err => {
            this.$toasted.show(err.body.mensagem, {
              icon: 'fa-warning',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    validadeInputs() {
      if (!this.schemas.length) {
        this.$toasted.show('Selecione pelo menos uma auto escola', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      if (!this.titulo) {
        this.$toasted.show('Preencha o título do aviso.', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      if (!this.user) {
        this.$toasted.show('Preencha o usuário do aviso.', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      if (!this.aviso) {
        this.$toasted.show('Preencha o conteúdo do aviso.', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
	display: flex;
	justify-content: center;
	align-items: center;
}

.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
    color: #606264;
  }

  .input {
    min-width: 15.0625rem !important;
    height: 2.738125rem !important;
    border: 1px solid #eaeaea !important;
    border-radius: 4px !important;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
  }
}

.main-form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .inputs-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }

      .input-processo {
        max-width: 26.625rem;
      }
    }
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

.usuario {
  margin-top: -20px;
}

#descricao {
  margin-top: -20px;
  margin-bottom: 30px;
}
</style>
